'use strict';

var carousel = require('../carousel'),
    timeout = SitePreferences.RECOMM_FORCE_INIT_DELAY || 0,
    productTile = require('./../product-tile');
  

// Force dispatch recommendations event second time
function forceInitRecomm() {

  setTimeout(function() {
    var einsteinContainer = document.querySelector('[id^="cq_recomm_slot"]');
    if (einsteinContainer && einsteinContainer.children.length > 0) {
      document.dispatchEvent(new CustomEvent("recommendations.loaded"));
      carousel.initAllRecommCarousels();
      productTile.init();
    }
  }, timeout);
  
}

module.exports = {
   init: function() {
     forceInitRecomm();
   }
};
